const sourcesFlatOptionsTransformer = response => {
  const flatten = arr => {
    return arr.reduce((acc, item) => {
      // Push current item
      acc.push({
        label: item.name,
        key: item.id.toString(),
        value: item.id.toString(),
      })

      // Recursively push children if exist
      if (item?.children?.length) {
        acc.push(...flatten(item.children))
      }

      return acc
    }, [])
  }

  return flatten(response)
}

export default sourcesFlatOptionsTransformer
